import { Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

interface INoInvoicesFound {
  doesFilterMatchFilterQueryParameters?: boolean;
}

const NoInvoicesFoundV2 = ({
  doesFilterMatchFilterQueryParameters,
}: INoInvoicesFound) => {
  const { t } = useTranslation("invoices");

  const errorSubtitleMessage = doesFilterMatchFilterQueryParameters
    ? t("allInvoices.noInvoicesFoundForOrder.v2")
    : t("allInvoices.changeFilters");

  return (
    <>
      <Typography
        sx={{
          textAlign: "center",
        }}
        component="p"
        variant="h2"
        data-testid="no-invoices-results"
      >
        {t("allInvoices.noInvoicesFound.v2")}
      </Typography>
      <Typography sx={{ margin: "12px" }}>{errorSubtitleMessage}</Typography>
    </>
  );
};

export default NoInvoicesFoundV2;
